module.exports = __webpack_public_path__ + "static/img/小程序.a1730bda.png";